<template>
  <section id="container" class="gnb_pdt">
    <div>
      <div class="title_wrap">
        <h1>수령 상세</h1>
      </div>
    </div>
    <!--  기본 정보  -->
    <div class="contents_wrap">
      <div class="small_title_wrap">
        <h2>기본 정보</h2>
      </div>
      <div class="box_flex">
      <div class="cmdp_photo w30">
        <span>
          <img
              v-show="fileSrc !== null"
              :src="fileSrc"
          >
          <img v-show="fileSrc == null"
               src="@/assets/img/etners-main/aiportal_img.png"
          >
        </span>
      </div>
      <ul class="filter_list user_photo_right mgl20">
        <li>
          <dd>
            <label class="w30">
              No.
            </label>
            <ul class="w70">
              <li>{{ receiveInfo.itemId }}</li>
            </ul>
          </dd>
          <dd>
            <label class="w30">
              진행 상태
            </label>
            <ul>
              <li>
                {{ receiveInfo.statusNm }}
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label class="w30">
              등록자
            </label>
            <ul class="w70">
              <li>
                {{ !!receiveInfo.frstRgstUserNm ? receiveInfo.frstRgstUserNm : receiveInfo.frstRgstId }} &nbsp;|&nbsp; {{ receiveInfo.frstRgstDt }}
              </li>
            </ul>
          </dd>
          <dd>
            <label class="w30">
              상태 여부
            </label>
            <ul class="w50">
              <li>
                {{ !!receiveInfo.terrorSignScnNm ? receiveInfo.terrorSignScnNm : '-' }}
              </li>
            </ul>
          </dd>
        </li>
        <li>
         <dd>
            <label class="w30">
              최종 메일 발송 일시
            </label>
            <ul class="w50">
              <li>
                {{ !!receiveInfo.hisDt ? receiveInfo.hisDt : '-' }}
                <button type="submit" class="mid_btn orange mgl10" @click="onClickSendFrstMail" v-show="receiveInfo.lockerYn === 'N' && receiveInfo.status==='01' && receiveInfo.hisDt === null">수령메일 발송</button>
                <button type="submit" class="mid_btn orange mgl10" :disabled="receiveInfo.lockerYn === 'Y' || receiveInfo.lockerYn === 'N' && receiveInfo.hisDt === null" @click="onClickSendMail" v-show="receiveInfo.status==='01'">독촉메일 발송</button>
              </li>
            </ul>
          </dd>
          <dd>
            <label class="w30">
              비고
            </label>
            <ul class="w50">
              <li>
                {{ !!receiveInfo.contents ? receiveInfo.contents : '-' }}
              </li>
            </ul>
          </dd>
        </li>
        <li>
         <dd>
          &nbsp;
         </dd>
          <dd>
            <label class="w30">
              취급구분/특송사
            </label>
            <ul class="w70">
              <li>
                {{ receiveInfo.receiveScnNm }}
                <span class="mgl10">{{ receiveInfo.shpcScnNm }}</span>
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            &nbsp;
          </dd>
          <dd>
            <label class="w30">
              운송장 번호
            </label>
            <ul class="w70">
              <li>
                {{ !!receiveInfo.blNo ? receiveInfo.blNo : '-' }}
              </li>
            </ul>
          </dd>
        </li>
      </ul>
      <!-- 최근 일자 상단 표기 -->
      <div class="w40">
        <h3>보관 이력</h3>
        <table class="basic_table" border="0" cellpadding="0" cellspacing="0">
                <colgroup>
                  <col class="w25" />
                  <col class="w25" />
                  <col class="w15" />
                  <col class="w35" />
                </colgroup>
                <tbody role="rowgroup">
                  <tr role="row">
                    <th class="txt_c">현황</th>
                    <th class="txt_c">보관 위치</th>
                    <th class="txt_c">보관함</th>
                    <th class="txt_c">담당자</th>
                  </tr>
                  <tr role="row" class="k-text-center"  v-if="historyList.length === 0">
                    <td class="mgt10" style="width:100%" colspan="4">표시할 데이터가 없습니다.</td>
                  </tr>
                  <tr v-else v-for="item in historyList">
                    <td>{{item.status}}</td>
                    <td>{{item.lockerNm}}</td>
                    <td>{{item.originId? item.originId : '-'}}</td>
                    <td>{{item.userNm}} {{item.frstRgstDt}}</td>
                  </tr>
<!--                  <tr>-->
<!--                    <td>무인보관함 등록</td>-->
<!--                    <td>H3 무인 보관함</td>-->
<!--                    <td>11</td>-->
<!--                    <td>김이트 2024/11/05 09:19</td>-->
<!--                  </tr>-->
<!--                  <tr>-->
<!--                    <td>변경</td>-->
<!--                    <td>h3 ㅇㅇㅇ문서실</td>-->
<!--                    <td>-</td>-->
<!--                    <td>홍길동 2024/11/05 09:19</td>-->
<!--                  </tr>-->
<!--                  <tr>-->
<!--                    <td>등록</td>-->
<!--                    <td>H3 무인 보관함</td>-->
<!--                    <td>11</td>-->
<!--                    <td>홍길순 2024/11/05 09:19</td>-->
<!--                  </tr>-->
<!--                  <tr>-->
<!--                    <td>변경</td>-->
<!--                    <td>H3 무인 보관함</td>-->
<!--                    <td>11</td>-->
<!--                    <td>김이트 2024/11/05 09:19</td>-->
<!--                  </tr>-->
                </tbody>
              </table>
      </div>
      </div>
    </div>
    <!--  상세정보[보내는 분]-->
    <div class="contents_wrap">
      <div class="small_title_wrap">
        <h2>상세 정보</h2>
      </div>
      <ul class="filter_list">
        <li>
          <dd>
            <label>
              발신
            </label>
            <ul class="w50">
              <li>
                <b class="txt_b">{{ !!receiveInfo.sendNm ? receiveInfo.sendNm : '-' }}</b>
              </li>
            </ul>
          </dd>
          <dd>
            <label>
              수량
            </label>
            <ul class="w50">
              <li>
                {{ !!receiveInfo.qty ? receiveInfo.qty : '-' }}
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>
              수신 회사
            </label>
            <ul class="w50">
              <li>
                {{ !!receiveInfo.receiveAreaScnNm ? receiveInfo.receiveAreaScnNm : '-' }}
              </li>
            </ul>
          </dd>
          <dd>
            <label>
              구분
            </label>
            <ul class="w50">
              <li>
                {{ !!receiveInfo.etcScnNm ? receiveInfo.etcScnNm : '-' }}
              </li>
            </ul>
          </dd>
        </li>
        <li>

          <dd>
            <label>
              보관 위치
            </label>
            <ul class="w50">
              <li>
                {{ !!receiveInfo.lockerNm ? receiveInfo.lockerNm : '-' }}
                <button type="submit" class="mid_btn orange mgl20" @click="onClickSteadReceive"  v-if="(receiveInfo.status==='01' || (receiveInfo.status === '97' && receiveInfo.steadYn === null)) && receiveInfo.lockerYn !== 'Y'">대리 수령</button>
                <button type="submit" class="mid_btn orange mgl10" @click="onClickMyReceive" v-if="(receiveInfo.status==='01' || (receiveInfo.status === '97' && receiveInfo.steadYn === null)) && receiveInfo.lockerYn !== 'Y'">본인 수령</button>
              </li>
            </ul>
          </dd>
        </li>
        <li>
        </li>
        <li>
          <dd>
            <label>
              물품 보관함 번호
            </label>
            <ul class="w50">
              <li>
                {{ !!receiveInfo.lockerCellId ? receiveInfo.lockerCellId : '-' }}
              </li>
            </ul>
          </dd>
        </li>
      </ul>
    </div>
    <!--  임직원 정보[받는 분]  -->
    <div class="contents_wrap">
      <div class="small_title_wrap">
        <h2>임직원 정보[받는 분]</h2>
      </div>
      <ul class="filter_list">
        <li>
          <dd>
            <label>
              사업장 / 거점
            </label>
            <ul class="w75">
              <li>
                {{ !!receiveInfo.facilityNm ? receiveInfo.facilityNm : '-' }}
                <span class="mgl10">{{ !!receiveInfo.areaNm ? receiveInfo.areaNm : '-' }}</span>
              </li>
            </ul>
          </dd>
          <dd>
            <label>
              코스
            </label>
            <ul class="w75">
              <li>
                {{ !!receiveInfo.courseNm ? receiveInfo.courseNm : '-' }}
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>
              수신 부서
            </label>
            <ul class="w50">
              <li>
                {{ !!receiveInfo.receiveDept ? receiveInfo.receiveDept : '-' }}
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>
              수신
            </label>
            <ul class="w50">
              <li>
                <b class="txt_b">{{ !!receiveInfo.receiveNm ? receiveInfo.receiveNm : '-' }}</b>
              </li>
            </ul>
          </dd>
           <dd>
            <label>
              사원번호
            </label>
            <ul class="w50">
              <li>
                {{ !!receiveInfo.receiveSabun ? receiveInfo.receiveSabun : '-' }}
              </li>
            </ul>
          </dd>
        </li>
        <li>
            <dd>
            <label>
              전화번호
            </label>
            <ul class="w50">
              <li>
                {{ !!receiveInfo.receiveTel ? receiveTel : '-' }}
              </li>
            </ul>
          </dd>
           <dd>
            <label>
              이메일
            </label>
            <ul v-if="receiveInfo.receiveEmailList.length > 0" class="mail_list">
              <span v-for="item in receiveInfo.receiveEmailList">
                {{item}}
              </span>
            </ul>
            <ul v-else>
               <li>
                 {{ '-' }}
               </li>
             </ul>
          </dd>
        </li>
        <li>

        </li>
        <li>
          <dd>
            <label>
              임원 여부
            </label>
            <ul class="w50">
              <li class="w100">
                {{ receiveInfo.executiveYn === 'Y' ? '임원' : '-' }}
                <span class="forg mgl30">임원인 경우 비서 이메일로 메일이 발송됩니다.</span>
              </li>
            </ul>
          </dd>

        </li>
        <li>
          <dd>
            <label>
              비서이름
            </label>
            <ul class="w50">
              <li>
                {{ !!receiveInfo.secretaryNm ? receiveInfo.secretaryNm : '-' }}
              </li>
            </ul>
          </dd>
          <dd>
            <label>
              비서 이메일
            </label>
            <ul class="w50">
              <li>
                {{ !!receiveInfo.secretaryEmail ? receiveInfo.secretaryEmail : '-' }}
              </li>
            </ul>
          </dd>
        </li>
      </ul>
    <!--수령정보-->
    <div class="contents_wrap">
      <div class="small_title_wrap">
        <h2>수령 정보<div class="forg mgl10">수령 완료 시 정보가 자동 입력됩니다. </div></h2>
      </div>
      <ul class="filter_list">
        <li>
          <dd>
            <label>수령인 타입</label>
            <ul class="w50">
              <li>
              {{ receiveInfo.steadYn === 'N' ? '본인 수령' : (receiveInfo.steadYn === 'Y' ? '대리 수령' : '-') }}
              </li>
            </ul>
          </dd>
          <dd>
            <label>
              수령인
            </label>
            <ul class="w50">
              <li>
                {{ receiveInfo.steadYn ? (receiveInfo.steadYn === 'N' ? receiveInfo.receiveNm : receiveInfo.steadNm) : '-' }}
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>
              용도
            </label>
            <ul class="w50">
              <li>
                {{ !!receiveInfo.ppsScnNm ? receiveInfo.ppsScnNm : '-' }}
              </li>
            </ul>
          </dd>
          <dd>
            <label>
              수령인 부서
            </label>
            <ul class="w50">
              <li>
                {{ receiveInfo.steadYn === 'N' ? receiveInfo.receiveDept : (receiveInfo.steadYn === 'Y' ? receiveInfo.steadDept : '-') }}
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>
              반입 목적
            </label>
            <ul class="w50">
              <li>
                {{ !!receiveInfo.receiPurposeNm ? receiveInfo.receiPurposeNm : '-' }}
                <a v-show="receiveInfo.receiPurpose === '03'"> {{ ' / ' + receiveInfo.receiPurposeDesc }} </a>
              </li>
            </ul>
          </dd>
          <dd>
            <label>
              수령 일시
            </label>
            <ul class="w50">
              <li>
                {{ !!receiveInfo.receiveDt ? receiveInfo.receiveDt : '-' }}
              </li>
            </ul>
          </dd>
        </li>
      </ul>
    </div>
    </div>
    <!--  버튼 영역  -->
    <div class="button_area w50">
      <ul>
        <li class="w15" v-if="receiveInfo.status!=='99'">
          <button type="submit" class="large_btn dgray" @click="onClickDeleteReceive">삭제</button>
        </li>
        <li class="w15" v-if="receiveInfo.status==='01'">
          <button type="submit" class="large_btn green" @click="onClickUpdateReceive">수정</button>
        </li>
        <li class="w15">
          <button type="button" class="large_btn" @click="redirectToList">목록</button>
        </li>
        <li class="w15 mgl20" v-if="receiveInfo.status==='02'">
          <button type="submit" class="large_btn orange" @click="onClickReceipt">전달 완료</button>
        </li>
      </ul>
    </div>
    <!--  추가 정보 입력 창  -->
    <create-stead-receive
        ref="createSteadReceiveWindowRef"
        @getUserData="steadReceiveSave"
    ></create-stead-receive>
    <create-stead-receive-inter-docu
        ref="createSteadReceiveInterDocuWindowRef"
        @getUserData="steadReceiveSave"
    ></create-stead-receive-inter-docu>
    <create-my-receive-inter-docu
        ref="createMyReceiveInterDocuWindowRef"
        @getUserData="myReceiveSave"
    ></create-my-receive-inter-docu>
  </section>
</template>
<script>
import ApiConfig from '@/api/api.config'
import ApiUtil from '@/api/api.util'
import CreateSteadReceive from '@/components/receive/CreateSteadReceive.vue'
import CreateSteadReceiveInterDocu from '@/components/receive/CreateSteadReceiveInterDocu.vue'
import CreateMyReceiveInterDocu from '@/components/receive/CreateMyReceiveInterDocu.vue'
import EtnersParseUtil from '@/common/etners.parse.util'
import EtnersCommonUtil from '@/common/etners.common.util'

export default {
  name: 'ReceiveDetail',
  components: {
    CreateSteadReceiveInterDocu,
    CreateMyReceiveInterDocu,
    CreateSteadReceive
  },
  mounted () {
    const vm = this
    vm.getReceiveDetail()
    vm.getHistoryList()
  },
  computed: {
    receiveTel () {
      return EtnersParseUtil.convertTelNo(this.receiveInfo.receiveTel)
    },
  },
  methods: {
    // 상세정보 불러오기
    getReceiveDetail () {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/receive/receiveDetail.json`
      const param = {
        loginUserToken: vm.loginUserToken,
        receiveId: vm.$route.params.receiveId
      }
      ApiUtil.post(url, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('정상적으로 처리되지 않았습니다.')
          return false
        }
        if (response.data.resultStatus.messageCode !== '2000') {
          if (response.data.resultStatus.messageCode === '4002') {
            kendo.alert(response.data.resultStatus.messageText)
            vm.$router.go(-1)
          } else {
            kendo.alert(response.data.resultStatus.messageText)
            return false
          }
        }
        let resultData = response.data.resultData
        vm.receiveInfo = resultData
        if (resultData.fileInfo !== null) {
          vm.fileSrc = `${ApiConfig.eklDomain}/files/2000/${resultData.fileInfo.fileId}/0?lutk=${vm.loginUserToken}`
        }
      })
    },
    // 목록으로 이동
    redirectToList () {
      this.$router.push({
        name: 'ReceiveList'
      })
    },
    // 수정 버튼
    onClickUpdateReceive () {
      const vm = this
      if (!vm.isSU && vm.receiveInfo.facility !== vm.loginUserData.facility) {
        kendo.alert('소속된 사업장의 물품만 수정 가능합니다.')
        return
      }
      vm.$router.push({
        name: 'ReceiveUpdate',
        params: {
          receiveId: vm.receiveInfo.receiveId,
        }
      })
    },
    // 삭제 버튼
    onClickDeleteReceive () {
      const vm = this
      if (!vm.isSU && vm.receiveInfo.facility !== vm.loginUserData.facility) {
        kendo.alert('소속된 사업장의 물품만 삭제 가능합니다.')
        return
      }
      if (EtnersCommonUtil.isNotEmpty(vm.receiveInfo.lockerCellId)) {
        kendo.alert('무인보관함에 보관중인 물품은 삭제가 불가능합니다.')
        return
      }
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/receive/receiveDelete.json`
      const param = {
        loginUserToken: vm.loginUserToken,
        receiveId: vm.receiveInfo.receiveId
      }
      kendo.confirm('해당 건을 삭제하시겠습니까?').done(function () {
        ApiUtil.post(url, param).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
            return false
          }
          const resultStatus = response.data.resultStatus
          if (resultStatus.messageCode !== '2000') {
            kendo.alert(resultStatus.messageText)
            return false
          }
          kendo.alert('삭제되었습니다.')
          vm.redirectToList()
        })
      })
    },
    // 본인 수령 버튼
    onClickMyReceive () {
      const vm = this
      if (!vm.isSU && vm.receiveInfo.facility !== vm.loginUserData.facility) {
        kendo.alert('소속된 사업장의 물품만 수정 가능합니다.')
        return
      }
      if (vm.receiveInfo.receiveScn === '09' && vm.receiveInfo.etcScn === '01') {
        vm.$refs.createMyReceiveInterDocuWindowRef.$refs.kendoWindowRef
          .kendoWidget()
          .center()
          .open()
      } else {
        vm.myReceiveSave(vm.userData)
      }
      vm.getReceiveDetail()
    },
    // 대리 수령 버튼
    onClickSteadReceive () {
      const vm = this
      if (!vm.isSU && vm.receiveInfo.facility !== vm.loginUserData.facility) {
        kendo.alert('소속된 사업장의 물품만 수정 가능합니다.')
        return
      }
      if (vm.receiveInfo.receiveScn === '09' && vm.receiveInfo.etcScn === '01') {
        vm.$refs.createSteadReceiveInterDocuWindowRef.$refs.kendoWindowRef
          .kendoWidget()
          .center()
          .open()
      } else {
        vm.$refs.createSteadReceiveWindowRef.$refs.kendoWindowRef
          .kendoWidget()
          .center()
          .open()
      }
      vm.getReceiveDetail()
    },
    // 본인 수령
    myReceiveSave (userData) {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/receive/receiveMySave.json`
      const params = {
        loginUserToken: vm.loginUserToken,
        receiveId: vm.receiveInfo.receiveId,
        receivePpsScn: userData.receivePpsScn,
        receivePurpose: userData.receivePurpose,
        receivePurposeDesc: userData.receivePurposeDesc,
      }
      kendo.confirm('본인 수령 처리 하시겠습니까?').done(() => {
        ApiUtil.post(url, params).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
            return false
          }
          const resultStatus = response.data.resultStatus
          if (resultStatus.messageCode !== '2000') {
            kendo.alert(resultStatus.messageText)
            return false
          }
          kendo.alert('본인 수령이 처리되었습니다.')
          vm.getReceiveDetail()
        })
      })
    },
    // 대리 수령
    steadReceiveSave (userData) {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/receive/receiveSteadSave.json`
      const params = {
        loginUserToken: vm.loginUserToken,
        receiveId: vm.receiveInfo.receiveId,
        receiveNm: userData.receiveNm,
        receiveDept: userData.receiveDept,
        receivePpsScn: userData.receivePpsScn,
        receivePurpose: userData.receivePurpose,
        receivePurposeDesc: userData.receivePurposeDesc,
      }
      kendo.confirm('대리 수령 처리하시겠습니까?').done(() => {
        ApiUtil.post(url, params).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
            return false
          }
          const resultStatus = response.data.resultStatus
          if (resultStatus.messageCode !== '2000') {
            kendo.alert(resultStatus.messageText)
            return false
          }
          kendo.alert('대리 수령 처리 되었습니다.')
          vm.getReceiveDetail()
        })
      })
    },
    // 수령 메일 발송(문서실)
    onClickSendFrstMail () {
      const vm = this
      if (!vm.isSU && vm.receiveInfo.facility !== vm.loginUserData.facility) {
        kendo.alert('소속된 사업장의 물품만 수정 가능합니다.')
        return
      }
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/receive/receiveInfoMail.json`
      const params = {
        loginUserToken: vm.loginUserToken,
        receiveId: vm.receiveInfo.receiveId,
      }
      kendo.confirm('<label style=\'text-align: center;\'>해당 건에 대해 메일 발송하시겠습니까?<br>발송된 메일은 취소가 불가능합니다.</label>')
          .done(() => {
            ApiUtil.post(url, params).then(response => {
              if (response.data === undefined || response.data.resultStatus === undefined) {
                kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
                return false
              }
              if (response.data.resultStatus.messageCode !== '2000') {
                kendo.alert(response.data.resultStatus.messageText)
                return false
              }
              kendo.alert('메일을 발송하였습니다.')
              vm.getReceiveDetail()
            })
          })
    },
    // 독촉 메일 발송
    onClickSendMail () {
      const vm = this
      if (!vm.isSU && vm.receiveInfo.facility !== vm.loginUserData.facility) {
        kendo.alert('소속된 사업장의 물품만 수정 가능합니다.')
        return
      }
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/receive/receiveReturnMail.json`
      const params = {
        loginUserToken: vm.loginUserToken,
        receiveId: vm.receiveInfo.receiveId,
      }
      kendo.confirm('<label style=\'text-align: center;\'>해당 건에 대해 메일 발송하시겠습니까?<br>발송된 메일은 취소가 불가능합니다.</label>')
        .done(() => {
          ApiUtil.post(url, params).then(response => {
            if (response.data === undefined || response.data.resultStatus === undefined) {
              kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
              return false
            }
            if (response.data.resultStatus.messageCode !== '2000') {
              kendo.alert(response.data.resultStatus.messageText)
              return false
            }
            kendo.alert('메일을 발송하였습니다.')
            vm.getReceiveDetail()
          })
        })
    },
    // 전달 완료 버튼
    onClickReceipt () {
      const vm = this
      const currentStatus = '02'
      const receiveIdList = []
      if (!vm.isSU && vm.receiveInfo.facility !== vm.loginUserData.facility) {
        kendo.alert('소속된 사업장의 물품만 수정 가능합니다.')
        return
      }
      if (vm.receiveInfo.status !== currentStatus) {
        kendo.alert('일괄 완료 처리는 접수 신청 상태만 가능합니다.')
        return
      }
      receiveIdList.push(vm.receiveInfo.receiveId)

      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/receive/batchUpdateReceive.json`
      const params = {
        loginUserToken: vm.loginUserToken,
        receiveIdList : receiveIdList,
        currentStatus : currentStatus
      }
      kendo.confirm('전달 완료 처리하시겠습니까?').done(() => {
        ApiUtil.post(url, params).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
            return false
            const resultStatus = response.data.resultStatus
            if (resultStatus.messageCode !== '2000') {
              kendo.alert(resultStatus.messageText)
              return false
            }
          }
          kendo.alert('전달 완료 처리 되었습니다.')
          vm.redirectToList()
        })
      })
    },
    getHistoryList () {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/item/historyList.json`
      const params = {
        loginUserToken: vm.loginUserToken,
        taskGbn: 'R',
        taskId: vm.receiveId,
      }
      ApiUtil.post(url, params).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        vm.historyList = response.data.resultData
      })
    },
  },
  data: function () {
    const loginUserData = JSON.parse(sessionStorage.getItem('loginUserData'))
    const isSU = loginUserData.authId === '9999'
    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      loginUserData: JSON.parse(sessionStorage.getItem('loginUserData')),
      isSU: isSU,
      receiveId: this.$route.params.receiveId,
      receiveInfo: {
        receiveEmailList : [],
      },
      userData: {
        receiveNm : null,
        receiveDept : null,
        receivePpsScn : null,
        receivePurpose : null,
        receivePurposeDesc : null,
      },
      fileSrc: null,
      historyList: [],
    }
  }
}

</script>

